// This file are for custom hooks
import { useRef, useEffect } from 'react';
// eslint-disable-next-line @typescript-eslint/no-explicit-any

// to prevent useEffect from running on intial render
export const useDidMountEffect = (func: () => void, deps: unknown[]): void => {
  const didMount = useRef(false);

  useEffect(() => {
    if (didMount.current) func();
    else didMount.current = true;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
};
